import React, { type ReactElement } from 'react';
import Alert from 'atom-components/alert';

export function NoTestReportsAvailable(): ReactElement {
  return <Alert variant="info">No cluster reports are enabled for the selected test.</Alert>;
}

export function NoAreaReportsAvailable(): ReactElement {
  return <Alert variant="info">No cluster reports are enabled for the selected area.</Alert>;
}

export default function NoReportsAvailable({ isTestView }: { isTestView: boolean }): ReactElement {
  if (isTestView) return <NoTestReportsAvailable />;
  return <NoAreaReportsAvailable />;
}
